// extracted by mini-css-extract-plugin
export default {"education":"Education_education__7Lg8+"};